export default __webpack_public_path__ + "static/media/argentan2.49bb9554.jpg";